import React from 'react'
import { render } from 'react-dom'
//import registerServiceWorker from './registerServiceWorker'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import createHistory from 'history/createBrowserHistory'
import { routerMiddleware } from 'react-router-redux'
import { BrowserRouter } from 'react-router-dom'
import reducers from './state'
import App from './components/App'
import { auth } from './lib'
import { login } from './state/user'

const history = createHistory()
const middlewares = [thunk, routerMiddleware(history)]
const store = createStore( reducers, applyMiddleware(...middlewares) )
//const middleware = routerMiddleware(history)
//const store = createStore( reducers, applyMiddleware(middleware) )

const user = auth.getUser()
if (user != null) store.dispatch(login(user))

render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)
//registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js